import { useCallback } from 'react';
import { useLogMarketAnalyticsEvent } from '../../../../../hooks/useLogMarketAnalyticsEvent';
import { isNil } from 'shared/src/utils';

export const useLogClickHeadlineXsmallOneLineToggle = (params: {
  listId: string | null;
  toggleType: string;
}) => {
  const logMarketAnalyticsEvent = useLogMarketAnalyticsEvent();
  return useCallback(
    (isOn: boolean) => {
      if (isNil(params.listId)) {
        return;
      }

      logMarketAnalyticsEvent({
        name: 'CLICK_HEADLINE_XSMALL_ONE_LINE_TOGGLE',
        analytics: {
          LIST_ID: params.listId,
          IS_ON: isOn ? '1' : '0',
          TOGGLE_TYPE: params.toggleType,
        },
      });
    },
    [logMarketAnalyticsEvent, params.listId, params.toggleType],
  );
};
